import { render, staticRenderFns } from "./pages-manage.vue?vue&type=template&id=132a8378&scoped=true"
import script from "./pages-manage.vue?vue&type=script&lang=js"
export * from "./pages-manage.vue?vue&type=script&lang=js"
import style0 from "./pages-manage.vue?vue&type=style&index=0&id=132a8378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a8378",
  null
  
)

export default component.exports